module.exports = __webpack_public_path__ + "img/gengduo.7024327f.png";